import React, { useEffect } from "react";
import { QuestionProps } from "../survey";
import TextArea from "../../components/data_entry/text_area";
import QuestionLabel from "./components/question_label";
import useRotatingQuestionIndex from "./hooks/useRotatingQuestion";

export interface Answer {
  prompt: string;
  answer: string;
  qid: string;
}

export interface Customizations {
  rotatingQuestions: { prompt: string; qid: string }[];
  placeholder?: string;
  optional?: boolean;
  description?: string;
}

export default function RotatingOpenResponse({
  customizations,
  currentAnswer,
  updateAnswer,
  setAbleToSubmit,
}: QuestionProps<Answer, Customizations>) {
  const { fetching, questionIndex } = useRotatingQuestionIndex({
    numberOfQuestions: customizations.rotatingQuestions.length,
  });
  const optional = typeof customizations.optional === "undefined" ? false : customizations.optional;
  const placeholder = customizations.placeholder;
  const description = customizations.description;
  const answerIsValid = optional || (currentAnswer?.answer?.length || 0) > 0;
  useEffect(() => {
    setAbleToSubmit(answerIsValid);
  }, [answerIsValid, setAbleToSubmit]);

  if (fetching || questionIndex === null) return <div>Loading...</div>;
  if (typeof questionIndex === "undefined") throw new Error("Failed to load rotating question");
  const question = customizations.rotatingQuestions[questionIndex];

  return (
    <div className="multi-select">
      <QuestionLabel
        label={question.prompt}
        questionIsOptional={optional}
        description={description}
      />
      <TextArea
        placeholder={
          placeholder ? placeholder : optional ? undefined : "Enter n/a if not applicable"
        }
        rows={4}
        questionIsOptional={optional}
        onChange={({ currentTarget: { value: updatedResponse } }) =>
          updateAnswer({
            prompt: question.prompt,
            qid: question.qid,
            answer: updatedResponse,
          })
        }
        value={currentAnswer ? currentAnswer.answer : ""}
      />
    </div>
  );
}
